
import { Component, Vue } from 'vue-property-decorator'
import { getMerchantsGroupList } from '@/api/customerManage'
import { Getter } from 'vuex-class'

@Component
export default class KpiMoreFilter extends Vue {
  @Getter companyId!: string
  params = {
    employeeName: '', // 员工姓名
    orderType: '', //  下单方式
    customerGroup: '', // 客户类别
  }

  orderTypeOptions = [
    {text: '全部', value: ''},
    {text: '代下单', value: 2},
    {text: '自主下单', value: 1}
  ]

  groupList = [{
    groupId: '',
    groupName: '全部分组'
  }]

  created () {
    this.getGroupList()
    let query = this.$route.query
    this.params.employeeName = query.employeeName as string
    this.params.orderType = query.orderType as string
    this.params.customerGroup = query.customerGroup as string
  }

  /**
   * 获取客户分组列表
   */
  getGroupList () {
    getMerchantsGroupList({}).then((res: any) => {
      this.groupList = this.groupList.concat(res.data.groupList || [])
    })
  }

  /**
   * @description: 下单方式选择事件
   */
  handleOrderTypeOptions (type) {
    this.params.orderType = type
  }

  /**
   * @description: 客户分组选择事件
   */
  handleGroupOptions (type) {
    this.params.customerGroup = type
  }

  /**
   * 取消
   */
  cancel () {
    this.$router.back()
  }

  /**
   * 重置
   */
  resetFunc () {
    this.params.employeeName = ''
    this.params.orderType = ''
    this.params.customerGroup = ''
  }

  /**
   * 确认
   */
  confirm () {
    this.$router.back()
    this.$eventBus.$emit('kpiMoreFilter', this.params)
  }
}
